



















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GCheckableItemListHeader',
  props: {
    withCheckbox: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
  },
});
